import type { ValidCurrency } from '@/types/plans';

import { type CurrencyBucket, getCurrencyBucket } from './config';

export type PricingTestFlagKey =
  | 'pricing-test-eur'
  | 'pricing-test-gbp'
  | 'pricing-test-usd-us'
  | 'pricing-test-usd-row'
  | 'pricing-test-inr'
  | 'pricing-test-aud'
  | 'pricing-test-brl';

const FLAG_KEY_BY_BUCKET: Record<CurrencyBucket, PricingTestFlagKey> = {
  EUR: 'pricing-test-eur',
  GBP: 'pricing-test-gbp',
  USD_US: 'pricing-test-usd-us',
  USD_ROW: 'pricing-test-usd-row',
  INR: 'pricing-test-inr',
  AUD: 'pricing-test-aud',
  BRL: 'pricing-test-brl',
};

export function getPricingTestFlagKey(
  currency: ValidCurrency,
  country: string
): PricingTestFlagKey | null {
  const bucket = getCurrencyBucket(currency, country);
  return bucket ? FLAG_KEY_BY_BUCKET[bucket] : null;
}
